/* Founders pricing countdown.
 *
 * Liquid already refuses to render an expired timer, so this only has to
 * handle the case of someone sitting on the page as it crosses zero.
 *
 * One interval drives every timer on the page rather than one each, and it
 * pauses while the tab is hidden so a backgrounded product page is not
 * ticking for no one.
 */
(function () {
  var SEL = '[data-founders-countdown]';
  var timer = null;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function expire(el) {
    el.classList.add('founders-countdown--expired');
    var msg = el.getAttribute('data-expired-text');
    var head = el.querySelector('.founders-countdown__heading');
    if (msg && head) { head.textContent = msg; }
    el.setAttribute('aria-label', msg || 'This offer has ended.');
    el.removeAttribute('data-founders-countdown');
  }

  function paint(el) {
    var deadline = parseInt(el.getAttribute('data-deadline'), 10);
    if (!deadline) { return false; }
    var left = deadline - Math.floor(Date.now() / 1000);
    if (left <= 0) { expire(el); return false; }

    var d = Math.floor(left / 86400);
    var h = Math.floor((left % 86400) / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = left % 60;

    var set = function (attr, val) {
      var node = el.querySelector('[' + attr + ']');
      if (node && node.textContent !== val) { node.textContent = val; }
    };
    set('data-cd-d', String(d));
    set('data-cd-h', pad(h));
    set('data-cd-m', pad(m));
    set('data-cd-s', pad(s));
    return true;
  }

  function tick() {
    var live = 0;
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) { if (paint(nodes[i])) { live++; } }
    if (!live) { stop(); }
  }

  function start() {
    if (timer !== null) { return; }
    tick();
    if (document.querySelector(SEL)) { timer = setInterval(tick, 1000); }
  }

  function stop() {
    if (timer !== null) { clearInterval(timer); timer = null; }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stop(); } else { start(); }
  });

  // Re-arm after theme-editor section reloads and after any AJAX swap that
  // brings a fresh timer into the DOM.
  document.addEventListener('shopify:section:load', start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
